import { autocompleteSelectClasses } from '@private/components';
import { getPrefixedVar } from '@private/payment';
import styled from 'styled-components';

import AutocompleteSelect from 'components/Controls/AutocompleteSelect';
import { COMPONENTS_NAMES } from 'theme/constants';

const prefix = ['components', COMPONENTS_NAMES.FILTERS];

export const ResetPresetButton = styled.button`
  flex: 0 0 15px;
  height: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  opacity: 0;
  visibility: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
  background: ${getPrefixedVar(prefix, 'resetPreset', 'base', 'bg')};
  color: ${getPrefixedVar(prefix, 'resetPreset', 'base', 'icon')};
  border-radius: ${getPrefixedVar(prefix, 'resetPreset', 'base', 'borderRadius')};

  &:hover {
    background: ${getPrefixedVar(prefix, 'resetPreset', 'hover', 'bg')};
    color: ${getPrefixedVar(prefix, 'resetPreset', 'hover', 'icon')};
  }

  &:active {
    background: ${getPrefixedVar(prefix, 'resetPreset', 'active', 'bg')};
    color: ${getPrefixedVar(prefix, 'resetPreset', 'active', 'icon')};
  }
`;

export const PresetsSelect = styled(AutocompleteSelect)`
  min-width: 300px;

  ${autocompleteSelectClasses.inputWrapper}:hover ${ResetPresetButton} {
    opacity: 1;
    visibility: visible;
  }

  /* The menu defaults to the input width, which is too narrow for longer
     localized preset names (uk: "Інформація про чарджбеки"). Let it grow past the
     input instead of wrapping every option onto two lines. */
  ${autocompleteSelectClasses.optionsWrapper} {
    width: max-content;
    min-width: 100%;
    max-width: 380px;
  }

  @media (width <= 1600px) {
    min-width: 180px;
    ${autocompleteSelectClasses.inputWrapper} {
      padding: 0 4px 0 8px;
    }
  }
`;
